var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/pubsub-js/src/pubsub.js
var require_pubsub = __commonJS({
  "node_modules/pubsub-js/src/pubsub.js"(exports, module) {
    (function(root, factory) {
      "use strict";
      var PubSub2 = {};
      if (root.PubSub) {
        PubSub2 = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
      } else {
        root.PubSub = PubSub2;
        factory(PubSub2);
      }
      if (typeof exports === "object") {
        if (module !== void 0 && module.exports) {
          exports = module.exports = PubSub2;
        }
        exports.PubSub = PubSub2;
        module.exports = exports = PubSub2;
      } else if (typeof define === "function" && define.amd) {
        define(function() {
          return PubSub2;
        });
      }
    })(typeof window === "object" && window || exports || global, function(PubSub2) {
      "use strict";
      var messages = {}, lastUid = -1, ALL_SUBSCRIBING_MSG = "*";
      function hasKeys(obj) {
        var key;
        for (key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return true;
          }
        }
        return false;
      }
      function throwException(ex) {
        return function reThrowException() {
          throw ex;
        };
      }
      function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
          subscriber(message, data);
        } catch (ex) {
          setTimeout(throwException(ex), 0);
        }
      }
      function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
      }
      function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage], callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions, s;
        if (!Object.prototype.hasOwnProperty.call(messages, matchedMessage)) {
          return;
        }
        for (s in subscribers) {
          if (Object.prototype.hasOwnProperty.call(subscribers, s)) {
            callSubscriber(subscribers[s], originalMessage, data);
          }
        }
      }
      function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
          var topic = String(message), position = topic.lastIndexOf(".");
          deliverMessage(message, message, data, immediateExceptions);
          while (position !== -1) {
            topic = topic.substr(0, position);
            position = topic.lastIndexOf(".");
            deliverMessage(message, topic, data, immediateExceptions);
          }
          deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
      }
      function hasDirectSubscribersFor(message) {
        var topic = String(message), found = Boolean(Object.prototype.hasOwnProperty.call(messages, topic) && hasKeys(messages[topic]));
        return found;
      }
      function messageHasSubscribers(message) {
        var topic = String(message), found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG), position = topic.lastIndexOf(".");
        while (!found && position !== -1) {
          topic = topic.substr(0, position);
          position = topic.lastIndexOf(".");
          found = hasDirectSubscribersFor(topic);
        }
        return found;
      }
      function publish(message, data, sync, immediateExceptions) {
        message = typeof message === "symbol" ? message.toString() : message;
        var deliver = createDeliveryFunction(message, data, immediateExceptions), hasSubscribers = messageHasSubscribers(message);
        if (!hasSubscribers) {
          return false;
        }
        if (sync === true) {
          deliver();
        } else {
          setTimeout(deliver, 0);
        }
        return true;
      }
      PubSub2.publish = function(message, data) {
        return publish(message, data, false, PubSub2.immediateExceptions);
      };
      PubSub2.publishSync = function(message, data) {
        return publish(message, data, true, PubSub2.immediateExceptions);
      };
      PubSub2.subscribe = function(message, func) {
        if (typeof func !== "function") {
          return false;
        }
        message = typeof message === "symbol" ? message.toString() : message;
        if (!Object.prototype.hasOwnProperty.call(messages, message)) {
          messages[message] = {};
        }
        var token = "uid_" + String(++lastUid);
        messages[message][token] = func;
        return token;
      };
      PubSub2.subscribeAll = function(func) {
        return PubSub2.subscribe(ALL_SUBSCRIBING_MSG, func);
      };
      PubSub2.subscribeOnce = function(message, func) {
        var token = PubSub2.subscribe(message, function() {
          PubSub2.unsubscribe(token);
          func.apply(this, arguments);
        });
        return PubSub2;
      };
      PubSub2.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
      };
      PubSub2.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            delete messages[m];
          }
        }
      };
      PubSub2.countSubscriptions = function countSubscriptions(topic) {
        var m;
        var token;
        var count = 0;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            for (token in messages[m]) {
              count++;
            }
            break;
          }
        }
        return count;
      };
      PubSub2.getSubscriptions = function getSubscriptions(topic) {
        var m;
        var list = [];
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            list.push(m);
          }
        }
        return list;
      };
      PubSub2.unsubscribe = function(value) {
        var descendantTopicExists = function(topic) {
          var m2;
          for (m2 in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m2) && m2.indexOf(topic) === 0) {
              return true;
            }
          }
          return false;
        }, isTopic = typeof value === "string" && (Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value)), isToken = !isTopic && typeof value === "string", isFunction = typeof value === "function", result = false, m, message, t;
        if (isTopic) {
          PubSub2.clearSubscriptions(value);
          return;
        }
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m)) {
            message = messages[m];
            if (isToken && message[value]) {
              delete message[value];
              result = value;
              break;
            }
            if (isFunction) {
              for (t in message) {
                if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value) {
                  delete message[t];
                  result = true;
                }
              }
            }
          }
        }
        return result;
      };
    });
  }
});

// src/utils/constants.js
var PUB_SUB_EVENTS = {
  colorChange: "color-change",
  sizeChange: "size-change",
  variantChange: "variant-change",
  blindsChange: "blinds-change",
  initialize: "initialize",
  onlyUpdateUrl: "only-update-url",
  blindsUpdatePrice: "blinds-update-price",
  updateControls: "update-controls",
  upsellChange: "upsell-change"
};

// src/utils/getSelectedOptionValues.js
var selectedOptionValues = () => {
  const productInfoElement = document.querySelector("product-info");
  const upsellFieldset = productInfoElement.querySelector('fieldset[name="upSell"]');
  const upsellSearchName = (upsellFieldset == null ? void 0 : upsellFieldset.getAttribute("data-search-name")) || "extra";
  const selectedValues = Array.from(productInfoElement.querySelectorAll("select option[selected], fieldset input:checked")).map(
    (input) => {
      const searchName = input.name && input.name.includes("_upSellIds") ? upsellSearchName : input.getAttribute("data-search-name");
      const returnObject = {
        name: input.name,
        value: input.value,
        productUrl: input.getAttribute("data-product-url"),
        searchName,
        optionValueId: input.getAttribute("data-option-value-id"),
        translatedValue: input.getAttribute("data-translated-value") || input.getAttribute("data-product-title")
      };
      if (input.value === "47562573906253") {
        returnObject.baseboard = true;
        returnObject.baseboardLeftHeight = productInfoElement.querySelector('fieldset[name="upSell"]').querySelector('input[name="baseboard_left_height"]').value, returnObject.baseboardLeftDepth = productInfoElement.querySelector('fieldset[name="upSell"]').querySelector('input[name="baseboard_left_depth"]').value;
        returnObject.baseboardRightHeight = productInfoElement.querySelector('fieldset[name="upSell"]').querySelector('input[name="baseboard_right_height"]').value;
        returnObject.baseboardRightDepth = productInfoElement.querySelector('fieldset[name="upSell"]').querySelector('input[name="baseboard_right_depth"]').value;
      }
      return returnObject;
    }
  );
  const sizingValue = {
    name: "size",
    value: {
      width: productInfoElement.querySelector("product-size").querySelector('input[name="width"]').value,
      height: productInfoElement.querySelector("product-size").querySelector('input[name="height"]').value
    }
  };
  const noteValue = {
    name: "note",
    value: productInfoElement.querySelector("product-note").querySelector('input[name="note"]').value,
    searchName: productInfoElement.querySelector("product-note").querySelector('input[name="note"]').getAttribute("data-search-name")
  };
  return [...selectedValues, sizingValue, noteValue];
};

// src/extenders/product-top-bottom-rail.js
var import_pubsub_js = __toESM(require_pubsub(), 1);
if (!customElements.get("product-top-bottom-rail")) {
  customElements.define(
    "product-top-bottom-rail",
    class ProductTopBottomRail extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.addEventListener("change", (event) => {
          const target = event.target;
          const closestFieldsetElement = target.closest("fieldset");
          import_pubsub_js.PubSub.publish(PUB_SUB_EVENTS.blindsChange, {
            data: {
              event,
              target,
              closestFieldsetElement,
              selectedOptionValues: this.selectedOptionValues
            }
          });
        });
      }
      get selectedOptionValues() {
        return selectedOptionValues();
      }
    }
  );
}
